<template>
  <div id="edit-project">
    <form novalidate @submit.prevent="updateJob">
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-snackbar v-model="infoUpdatedSnack">
            <span>{{'jobs._job_succ_'|translate}}</span>
            <v-btn class="md-primary" @click="infoUpdatedSnack = false">{{'general._ok_'|translate}}</v-btn>
          </v-snackbar>
          <!-- project form -->
          <v-toolbar :md-elevation="1">
            <span class="md-title">{{'jobs._job_name_'|translate}} : <b>{{form.title}}</b></span>
            <span class="md-title"> {{'jobs._createdDate_'|translate}} : <b>{{ form.created_date }}</b></span>
          </v-toolbar>
          <br>

          <v-flex sm6 style="display:none">
            <v-text-field
              :label="$t('jobs._job_name_')"
              type="text"
              autocomplete="given-name"
              v-model="job_id"
              required
            ></v-text-field>
          </v-flex>

                  <v-flex xs12 sm6>
                  
            <v-select
              :items="projects"
              v-model="form.project_id"
                :label="$t('jobs._select_proj_')"
              item-text="title"
              item-value="id"
              single-line
            ></v-select>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
               :label="$t('jobs._job_name_')"
              v-model="form.title"
              autocomplete="given-name"
              required
            ></v-text-field>
          </v-flex>
      <v-flex xs12 sm6>
            <v-widget title="Date de d'achèvement du project" class="mt-3">
              <div slot="widget-content">
                <v-dialog
                  ref="dialog"
                  persistent
                  v-model="modal"
                  lazy
                  full-width
                  width="290px"
                  :return-value.sync="date"
                >
                  <v-text-field
                    slot="activator"
                    :label="$t('jobs._expiration_data_')"
                    v-model="form.job_end_date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="form.job_end_date" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="modal = false">{{'general._cancel_'|translate}}</v-btn>
                    <v-btn flat color="primary" @click="$refs.dialog.save(date)">{{'general._ok_'|translate}}</v-btn>
                  </v-date-picker>
                </v-dialog>
              </div>
            </v-widget>
          </v-flex>
          <v-flex xs12>
            <h5>{{'jobs._Description_'|translate}}</h5>

            <v-textarea
              placeholder="Détailler"
              ref="projectDescription"
              v-model="form.description"
              :min-height="30"
              :max-height="350"
              required
              outline
            ></v-textarea>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              :label="$t('jobs._weekly_hours_')"
              type="number"
              min="0"
              v-model.number="form.weekly_hours"
              required
              suffix="heures"
            ></v-text-field>
          </v-flex>

                   <v-flex xs12 sm6>
            <v-text-field
             :label="$t('jobs._pos_nums_')"
              
              type="number"
              min="0"
              v-model.number="form.available_position"
              required
              suffix="position"
            ></v-text-field>
          </v-flex>

 <!--              <v-flex xs12 sm6>
               <v-text-field
              label="Nom du projet"
              type="text"
              autocomplete="given-name"
              v-model="form.project_name"
              required
            ></v-text-field>
          </v-flex> -->



        <v-flex xs12 sm6>
            <v-text-field
            :label="$t('jobs._skills_required_')"
              type="text"
              autocomplete="given-name"
              v-model="form.skills_required"
              required
            ></v-text-field>
          </v-flex>
   


          
          <v-flex xs12 sm6>
            <v-text-field
              :label="$t('jobs._hourly_wages_')"
              type="number"
              min="0"
              v-model="form.hourly_wages"
              required
                suffix="dollar"
            ></v-text-field>
          </v-flex>

 
          <v-flex xs12 sm6>
            <v-select
              :items="job_type"
              v-model="form.type"
              :label="$t('jobs._type_')"
              item-text="type"
              item-value="abbr"
              single-line
            ></v-select>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
               :label="$t('coupons._cop_city_')"
              type="text"
              autocomplete="name"
              
              v-model="form.city"
            ></v-text-field>
          </v-flex>
            <v-flex xs12 sm6>
            <v-text-field
               :label="$t('coupons._cop_region_')"
              type="text"
              autocomplete="region"
              
              v-model="form.region"
            ></v-text-field>
          </v-flex>
            <v-flex xs12 sm6>
            <v-text-field
                :label="$t('coupons._cop_civic_')"
              type="text"
              autocomplete="civic"
              
              v-model="form.civic"
            ></v-text-field>
          </v-flex>

                     <v-flex xs12 sm6>
            <v-text-field
              :label="$t('coupons._cop_postalCode_')"
              type="text"
              autocomplete="postalCode"
              
              v-model="form.postalCode"
            ></v-text-field>
          </v-flex>


       <v-flex xs12>
            <v-layout row wrap>
              <v-card-actions style="display:inline">
                <v-btn @click="deleteJob" color="primary">{{'general._delete_'|translate}}</v-btn>
              </v-card-actions>

              <v-card-actions style="display:inline">
                <router-link :to="{ name: 'widget-post'}">
                  <v-btn color="primary">{{'general._back_'|translate}}</v-btn>
                </router-link>
              </v-card-actions>

              <v-spacer></v-spacer>
              <v-card-actions style="display:inline">
                <v-btn type="submit" color="primary">{{'general._save_'|translate}}</v-btn>
              </v-card-actions>
            </v-layout>
          </v-flex>

        </v-layout>
      </v-container>
    </form>
  </div>
</template>

<script>
/* eslint-disable */
import { db } from "@/api/firebaseInit";
import firebase from "firebase";
import { storage } from '@/api/firebaseInit';
import vueSlider from "vue-slider-component";
import { quartiers } from "@/api/quartiers";
import { communes } from "@/api/communes";

const toLower = text => {
  return text.toString().toLowerCase();
};

const searchByName = (items, term) => {
  if (term) {
    return items.filter(item => toLower(item.title).includes(toLower(term)));
  }

  return items;
};

export default {
  name: "edit-job",
  components: {
    vueSlider
  },
    computed: {
    projects(){
      let projects =  this.$store.getters.projects;
      return projects;
    } 
  },
  mounted() {  
 // this.projects =  this.$store.getters.projects;
   //  console.log(" projects "+JSON.stringify(this.projects))     
  },
  created() {
    
    this.job_id = this.$route.params.job_id;
    this.created_by_id = firebase.auth().currentUser.uid;
    this.created_by = firebase.auth().currentUser.displayName;
  
  },
  filters: {
    formatDate: function(value) {
      if (value) {
        return moment(String(value)).format("MM/DD/YYYY");
      }
    }
  },
  data() {
    return {
      //projects:[],
      old_images:[],
      members: [],
      loading: true,
      pagination: {
        sortBy: "title",
        rowsPerPage: "100"
      },
      job_type: ["Part-Time", "Full-Time"],
      date: null,
      menu: false,
      modal: false,
      infoUpdatedSnack: false,
      jobs: [],
      backers: [],
      zones: quartiers,
      areas: communes,
      job_id: null,
      form: {
        updatedBy: firebase.auth().currentUser.displayName,
        city:'',
        civic:'',
        region:'',
        postalCode:'',
        available_position:0,
        created_by_id:firebase.auth().currentUser.uid, 
        created_date:'', 
        description:'', 
        hourly_wages:0,
        job_end_date:'', 
        project_id:'',
        //project_name:'', 
        skills_required:[],
        start_date:new Date, 
        title:'',
        type:'',
        weekly_hours:0 
      }
    };
  },
  beforeRouteEnter(to, from, next) {
    db.collection("Jobs")
      .doc(to.params.job_id)
      .get()
      .then(function(doc) {
        next(vm => {

                 (vm.form.city=doc.data().address.city),
                 (vm.form.civic=doc.data().address.civic),
                 (vm.form.region=doc.data().address.region),
                 (vm.form.postalCode=doc.data().address.postalCode),
                 (vm.form.available_position= doc.data().available_position),
                 (vm.form.created_by_id= doc.data().created_by_id), 
                 (vm.form.created_date= doc.data().created_date), 
                 (vm.form.description= doc.data().description), 
                 (vm.form.hourly_wages= doc.data().hourly_wages),
                 (vm.form.job_end_date= doc.data().job_end_date), 
                 (vm.form.project_id= doc.data().project_id),
                /*  (vm.form.project_name= doc.data().project_name),  */
                 (vm.form.skills_required= doc.data().skills_required+""),
                 (vm.form.start_date= doc.data().start_date), 
                 (vm.form.title= doc.data().title), 
                 (vm.form.type= doc.data().type),
                 (vm.form.weekly_hours= doc.data().weekly_hours);  

        });
      });
  },
  watch: {
    $route: "fetchData"
  },
  methods: {

    searchOnTable() {
      this.searched = searchByName(this.jobs, this.search);
    },
    getClass: ({ type }) => ({
      // 'md-primary':
    }),
    onSelect(item) {
      this.selected = item;
      this.$router.push({
        name: "edit-job",
        params: {
          job_id: item.job_id
        }
      });
    },
    fetchData() {
      db.collection("Jobs")
        .doc(this.job_id)
        .get()
        .then(function(doc) {
              (this.form.city=doc.data().address.city),
                 (this.form.civic=doc.data().address.civic),
                 (this.form.region=doc.data().address.region),
                 (this.form.postalCode=doc.data().address.postalCode),
                (this.form.available_position= doc.data().available_position),
                 (this.form.created_by_id= doc.data().created_by_id), 
                 (this.form.created_date= doc.data().created_date), 
              (this.form.description= doc.data().description), 
                (this.form.hourly_wages= doc.data().hourly_wages),
                 (this.form.job_end_date= doc.data().job_end_date), 
              (this.form.project_id= doc.data().project_id),
           /*    (this.form.project_name= doc.data().project_name),  */
            (this.form.skills_required= doc.data().skills_required+""),
              (this.form.start_date= doc.data().start_date), 
                (this.form.title= doc.data().title), 
                 (this.form.type= doc.data().type),
                (this.form.weekly_hours= doc.data().weekly_hours);              
        });
    },

    updateJob() {
      var that = this;
      var address ={}
      var skills_required = this.form.skills_required.split(',');

      address.city= this.form.city
      address.civic= this.form.civic
      address.region= this.form.region
      address.postalCode= this.form.postalCode
      console.log("skills ",skills_required+ " address "+JSON.stringify(address))
      db.collection("Jobs")
        .doc(this.job_id)
        .update({
            
                address: address,
                available_position:this.form.available_position,
                created_by_id:this.form.created_by_id, 
                created_date:new Date(), 
                description:this.form.description, 
                hourly_wages:this.form.hourly_wages,
                job_end_date:this.form.job_end_date, 
                project_id:this.form.project_id,
              /*   project_name:this.form.project_name,  */
                skills_required:skills_required,
               // start_date:this.form.start_date, 
                title:this.form.title, 
                type:this.form.type,
                weekly_hours:this.form.weekly_hours 
             
        })
        .then(() => {
          that.infoUpdatedSnack = true;
             this.$store.dispatch('fetchJobs')
        })
        .catch(error => {
          console.error("Error adding member: ", error);
        });
      
    },

    backtoRoute () {
       return '/widget-post';
    },
    deleteJob() {
      var that = this;
      if (confirm("Are you sure?")) {
        db.collection("Jobs")
          .doc(this.job_id)
          .delete()
          .then(function() {
            alert(`Cette Job a été suprimé`);
            this.$store.dispatch('fetchJobs')
            this.$router.push({name: 'widget-post'});
          });
      }
    },
  }
};
</script>
<style lang='scss' scoped>
.md-dialog {
  max-width: 768px;
}
body {
  padding-top: 70px;
}
.md-drawer {
  padding-top: 70px;
}

#my-strictly-unique-vue-upload-multiple-image {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/pages/modifiers/EditJob.vue